import { render, staticRenderFns } from "./HistoryDetail.vue?vue&type=template&id=dd5732a2&scoped=true&"
import script from "./HistoryDetail.vue?vue&type=script&lang=ts&"
export * from "./HistoryDetail.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryDetail.vue?vue&type=style&index=0&id=dd5732a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5732a2",
  null
  
)

export default component.exports